export default "__VITE_ASSET__BqPGCjgZ__";